import React, { useState, useRef } from 'react';
import { FaEnvelope, FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const form = useRef();
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
      alert('Please fill in all required fields');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus('sending');
    
    // Send email using EmailJS
    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      form.current, 
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setSubmitStatus('success');
        
        // Clear form
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      })
      .catch((error) => {
        console.error('Failed to send email:', error.text);
        setSubmitStatus('error');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  
  // Redirect to email client instead of sending via EmailJS
  const handleRedirectToEmail = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;
    const mailto = `mailto:gvahealthtechpvtltd@gmail.com?subject=${encodeURIComponent(subject || 'Contact Form Submission')}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\n\n${message}`
    )}`;
    window.location.href = mailto;
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Contact Us</h2>
        <div className="contact-content">
          <div className="contact-form">
            {submitStatus === 'success' && (
              <div className="success-message">
                Thank you for your message. We will get back to you soon!
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="error-message">
                Sorry, there was an error sending your message. Please try again later.
              </div>
            )}
            
            <form id="contactForm" onSubmit={handleRedirectToEmail} ref={form}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <input type="hidden" name="to_email" value="vishal27shetty@gmail.com" />
              <button 
                type="submit" 
                className="btn-primary" 
                disabled={isSubmitting}
              >
                {'Send Message'}
              </button>
            </form>
          </div>
          
          <div className="contact-info">
            <div className="contact-method">
              <FaEnvelope />
              <h3>Email Us</h3>
              <p>gvahealthtechpvtltd@gmail.com</p>
            </div>
            <div className="contact-method">
              <FaLinkedin />
              <h3>Connect on LinkedIn</h3>
              <p>
                <a href="https://www.linkedin.com/in/vishal-shetty27/" target="_blank" rel="noopener noreferrer">
                  linkedin.com/in/vishalshetty
                </a>
              </p>
              <p>
                <a href="https://www.linkedin.com/in/gauravnirmalkumar/" target="_blank" rel="noopener noreferrer">
                  linkedin.com/in/gauravnirmalkumar
                </a>
              </p>
              <p>
                <a href="https://www.linkedin.com/in/aditya-boguda-vishwanath-42830b287/" target="_blank" rel="noopener noreferrer">
                  linkedin.com/in/adtiyaboguda
                </a>
              </p>
              <p>
                <a href="https://www.linkedin.com/in/dr-suyash-gupta-ba1b5599/" target="_blank" rel="noopener noreferrer">
                  linkedin.com/in/suyashgupta
                </a>
              </p>
            </div>
            <div className="social-links">
              <a href="#" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;